import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import NotificationItem from "./item";
import './index.css'
import NoData from "../no-data";
import ClassWatcher from "../../hooks/ClassWatcher";
import Loading from "../loading";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import NotificationStaticItem from "./static-item";
import SvgIcon from "../svg-icon";
import moment from "moment/moment";
import {useNavigate} from "react-router-dom";

const limit = 50
const Notifications = (props) => {
    const [activeType, setActiveType] = useState('')

    const {hasUnreadNotifications, handleReFetchNotifications} = props

    const {activeLanguage} = useSelector(state => state.globalReducer)
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [messages, setMessages] = useState([])
    const {t} = useTranslation()

    const getNotifications = () => {
        setLoading(true)
        associateServices.getNotifications({
            page: 1,
            limit,
            lang: activeLanguage?.key
        }).then(res => {
            const data = res?.data?.operator?.data?.concat(res?.data?.system || [])?.sort((b, a) => parseFloat(a.timestamp) - parseFloat(b.timestamp))
            setData(data)
            setLoading(false)
        })
    }
    const getMessages = () => {
        setLoading(true)
        associateServices.getMessages({
            page: 1,
            limit,
        }).then(res => {
            setMessages(res?.data?.data || [])
            setLoading(false)
        })
    }

    function workOnClassAdd() {
        // console.log("I'm triggered when the class is added")
        setActiveType('notifications')
    }

    function workOnClassRemoval() {
        // console.log("I'm triggered when the class is removed")
    }

    useEffect(() => {
        let targetNode = document.getElementById('notifications-wrapper')
        new ClassWatcher(targetNode, 'show', workOnClassAdd, workOnClassRemoval)
    }, [])

    useEffect(() => {
        activeType === 'notifications' ? getNotifications() : getMessages()
    }, [activeType])

    const handleMarkNotificationsAsRead = e => {
        e.stopPropagation()

        activeType === 'notifications' ?
            associateServices.markNotifications({}).then(res => {
                if (res?.status === 200)
                    handleReFetchNotifications()
            })
            :
            associateServices.markMessages({}).then(res => {
                if (res?.status === 200)
                    handleReFetchNotifications()
            })
    }


    const navigate = useNavigate()

    const types = ['notifications', 'messages']


    const handleClick = message => {
        if (!message.path)
            return false


        if (message?.path?.includes('http') || message?.path?.includes('https'))
            window.open(message?.path, '_blank')

        navigate(message?.path)
    }
    return (
        <div
            id="notifications-wrapper"
            className="dropdown-menu dropdown-menu-end header__notifications"
            aria-labelledby="dropdownNotifications">


            <ul
                className="nav nav-tabs tabs-nav w-100 gap-2"
                id="tabs-nav"
                role="tablist"
            >

                {
                    types?.map(type => (
                        <li className="nav-item" role="presentation" key={type}>
                            <button
                                onClick={e => {
                                    e.stopPropagation()
                                    setActiveType(type)
                                }}
                                className={`tabs-nav__btn ${activeType === type ? 'active' : ''} gap-2`}
                                type="button">
                                <SvgIcon id={type === 'notifications' ? 'notifications' : 'chat'}/>
                                {t(`notifications.${type}`, type)}

                                {
                                    hasUnreadNotifications[type] >= 1 ?
                                        <div className="notification-counter">
                                            {/*<span>{hasUnreadNotifications[type]}</span>*/}
                                        </div> : null
                                }
                            </button>
                        </li>
                    ))
                }

            </ul>

            {
                loading ? <Loading/> : data?.length <= 0 ? <NoData desc={t('notifications.no-notification')}/> :

                    <ul className="header__notes">
                        {

                            activeType === 'messages' ?

                                messages?.length <= 0 ?
                                    <div className="container">
                                        <NoData desc={t('notifications.no-notification')}/>
                                    </div>
                                    :

                                    messages?.map(oo => (
                                        <li key={oo?.id}>
                                            <a onClick={null}
                                               className="green gap-2 d-flex flex-row align-items-center">
                                                <div className="d-flex align-items-center justify-content-center gap-2">
                                                    <SvgIcon id={'ti-info-circle'}/>

                                                    <div onClick={e => handleClick(oo)}
                                                         dangerouslySetInnerHTML={{__html: oo?.description}}/>
                                                </div>

                                            </a>
                                        </li>
                                    )) :
                                data?.map((notification, i) =>
                                    notification.is_static ?
                                        <NotificationStaticItem key={i}
                                                                notification={notification}/>
                                        :
                                        <NotificationItem key={i}
                                                          notification={notification}/>)
                        }
                    </ul>

            }

            {
                !loading && data?.length >= 1 && hasUnreadNotifications[activeType] >= 1 &&
                <button
                    onClick={handleMarkNotificationsAsRead}
                    className="header__dropdown-btn" type="button">
                    <SvgIcon id={'unread'}/>
                    {t('notifications.mark-all-as-read')}
                </button>
            }
        </div>
    )
}

export default Notifications
